import React from "react";
import PropTypes from "prop-types";

export default function StatusTags({
  accHold,
  qcHold,
  qcPreapprovalRequired,
  exportHold,
  deniedPartyHold,
  newCompanyHold
}) {
  return (
    <div>
      {accHold && (
        <span className="label label-danger" style={{ marginRight: 10 }}>
          <i className="fa fa-warning" />
          <span className="with-padding">Acc Hold</span>
        </span>
      )}
      {qcPreapprovalRequired && (
        <span className="label label-danger" style={{ marginRight: 10 }}>
          <i className="fa fa-pause" />
          <span className="with-padding">QC Pre. Req.</span>
        </span>
      )}
      {exportHold && (
        <span className="label label-danger" style={{ marginRight: 10 }}>
          <i className="fa fa-pause" />
          <span className="with-padding">Export Hold</span>
        </span>
      )}
      {qcHold && (
        <span className="label label-danger">
          <i className="fa fa-pause" />
          <span className="with-padding">QC Hold</span>
        </span>
      )}
      {deniedPartyHold && (
        <span className="label label-danger" style={{ marginRight: 10 }}>
          <i className="fa fa-pause" />
          <span className="with-padding">Denied Party Hold</span>
        </span>
      )}
      {newCompanyHold && (
        <span className="label label-danger">
          <i className="fa fa-warning" />
          <span className="with-padding">New Company Hold</span>
        </span>
      )}
    </div>
  );
}

StatusTags.propTypes = {
  accHold: PropTypes.bool.isRequired,
  qcHold: PropTypes.bool.isRequired,
  qcPreapprovalRequired: PropTypes.bool.isRequired,
  exportHold: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Search/StatusTags.jsx